import { render, staticRenderFns } from "./courseDetailCef.vue?vue&type=template&id=383c453d&"
import script from "./courseDetailCef.vue?vue&type=script&lang=js&"
export * from "./courseDetailCef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports